export const checkDevMode = () => {
    const devUrl = 'www.junior-dev.mts-corp.ru';
    return window.location.hostname === devUrl || window.location.hostname === 'localhost';
};
